import { render, staticRenderFns } from "./allstadium.vue?vue&type=template&id=01102780&"
import script from "./allstadium.vue?vue&type=script&lang=ts&"
export * from "./allstadium.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports